'use client';
import { Metadata } from 'next';

import { GlobalErrorPage } from '@/pages/Error';

export const metadata: Metadata = {
  title: 'Ошибка - Документация Cloud',
  description: 'Документация: Ошибка. Изучите руководство и инструкцию в разделе: Cloud.',
};

export default function ErrorPage() {
  return <GlobalErrorPage />;
}
